<template>
  <modal name="helpModal" :header="$t('functional.help')">
    <div class="help">
      <tabs v-if="$store.state.config" :key="`tabs-csq-${$store.getters.canShowQuestions}`">
        <tab :name="$t('help.isThisLegal')" property="is-this-legal" id="1" iconName="pencil" isActive="true">
          <h3>{{ $t('help.isThisLegal') }}</h3>
          <i18n path="help.legalityInfo" tag="p">
            <a place="eIDAS" href="https://www.signable.co.uk/what-is-eidas/" target="_blank">{{ $t('help.eIDAS') }}</a>
            <a place="ESIGN" href="https://www.signable.co.uk/esignatures-explained/" target="_blank">{{ $t('help.ESIGN') }}</a>
            <a place="legalPage" href="https://www.signable.co.uk/legal/" target="_blank">{{ $t('help.legalPage') }}</a>
            <a place="contactPage" href="https://www.signable.co.uk/contact/" target="_blank">{{ $t('help.contactPage') }}</a>
          </i18n>
        </tab>
        <tab :name="$t('help.whatIsSignable')" property="what-is-signable" id="2" iconName="question">
          <h3>{{ $t('help.whatIsSignable') }}</h3>
          <i18n path="help.signableDescription" tag="p">
            <a place="contactPage" href="https://www.signable.co.uk/contact/" target="_blank">{{ $t('help.contactPage') }}</a>
            <b place="companyName">{{ $store.state.config.company_name }}</b>
          </i18n>
        </tab>
        <tab
          :name="$t('help.contactCompany', { companyName: $store.state.config.company_name })"
          property="contact-signable-team"
          id="3"
          iconName="paper-plane"
          v-if="$store.getters.canShowQuestions">
          <div>
            <h3>{{ $t('help.contactCompany', { companyName: $store.state.config.company_name }) }}</h3>
            <p v-if="!messageSent">{{ $t('help.contactFormInfo', { companyName: $store.state.config.company_name }) }}</p>
            <form class="help__contact-us" v-if="!messageSent">
              <textarea ref="contact"></textarea>
              <BaseButton
                @click.native="contact"
                class="float-right"
              >
                {{ $t('functional.send') }}
              </BaseButton>
            </form>
            <message type="success" v-else>
              <h3>{{ $t('help.messageSent') }}</h3>
              <span>{{ $t('help.responseInfo') }}</span>
            </message>
          </div>
        </tab>
      </tabs>
      <template slot="modalButtons" slot-scope="props">
        <BaseButton
          @click.native="props.close"
          variant="secondary"
        >
          {{ cancelButtonText }}
        </BaseButton>
      </template>
    </div>
    <template slot="modalButtons" slot-scope="props">
      <BaseButton
        @click.native="props.close"
        variant="secondary"
      >
        {{ $t('functional.close') }}
      </BaseButton>
    </template>
  </modal>
</template>

<script>
import BaseButton from '@/components/library/buttons/BaseButton'
import Tabs from '@/components/Tabs'
import Tab from '@/components/Tab'
import Message from '@/components/Message'
import Modal from '@/components/Modal'
import axios from 'axios'
import amplitude from 'amplitude-js'

export default {
  name: 'helpPopup',
  components: {
    BaseButton,
    Tabs,
    Tab,
    Message,
    Modal
  },
  data () {
    return {
      messageSent: false
    }
  },
  computed: {
    cancelButtonText () {
      return this.showModalButtons ? this.$t('functional.noThanks') : this.$t('functional.close')
    }
  },
  methods: {
    contact () {
      const textarea = this.$refs.contact.value
      if (window.IS_PREVIEW) {
        alert(this.$t('help.previewWarning'))
      } else if (textarea.length > 0) {
        axios.post(`${process.env.VUE_APP_API_URL}/send-message`, {
          message: textarea,
          to: 'sender'
        })
          .then((response) => {
            if (response.data === '') {
              amplitude.getInstance().logEvent('message_sent')
              this.messageSent = true
            }
          })
      } else {
        alert(this.$t('help.enterAMessage'))
      }
    }
  }
}
</script>

<style lang="sass" scoped>
  @import '@/styles/component-utils.sass'
  .help
    line-height: 1.5
    p
      margin-bottom: 0
    textarea
      max-width: 100%
      width: 100%
      min-height: 150px
      margin-top: $spacing-small
      margin-bottom: $spacing-small
      font-size: inherit
      font: inherit
      color: inherit
</style>
